import { toast as pushToast } from "@/hooks/use-toast";

type ToastPayload = Parameters<typeof pushToast>[0];
type ToastFn = (payload: ToastPayload) => unknown;

function getErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return "Неизвестная ошибка";
}

export function notifyModuleSuccess(toast: ToastFn, title: string): void {
  toast({ title });
}

export function notifyModuleError(toast: ToastFn, actionLabel: string, error: unknown): void {
  toast({
    title: `Ошибка: ${actionLabel}`,
    description: getErrorMessage(error),
    variant: "destructive",
  });
}

